<template>
    <section class="app-main">
     
        <div class="top-bar">
            <el-input placeholder="输入商品名称查询" v-model="name" @change="search" prefix-icon="el-icon-search" style="width:260px;" clearable></el-input>
        </div>

        <el-card>
            <el-table ref="multipleTable" :data="tableData" height="600"  @selection-change="handleSelect" >
                <!-- <el-table-column type="selection" width="60" align="center"> </el-table-column> -->
                <el-table-column prop="user_info.nickname" label="用户" width="150"  align="center"></el-table-column>
                <el-table-column prop="goods_info.name" label="商品名称"  width="240"  align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  label="评论详情" min-width="300">
                    <template slot-scope="scope">
                        <div class="stars">
                            <p>商品评价： <el-rate v-model="scope.row.s_comment" :colors="colors"  disabled class="icon-star"></el-rate>{{scope.row.s_comment}}</p>
                            <p>物流运输： <el-rate v-model="scope.row.w_comment" :colors="colors"  disabled class="icon-star"></el-rate>{{scope.row.w_comment}}</p>
                            <p>服务评分： <el-rate v-model="scope.row.f_comment" :colors="colors"  disabled class="icon-star"></el-rate>{{scope.row.f_comment}}</p>
                        </div>
                        <p class="m-bottom-3">评论：{{scope.row.content}}</p>
                        <m-video v-if="scope.row.video_url" :video.sync="scope.row.video_url"  :width="70" :height="70" file-name="goodsVideo" ></m-video>
                        <div v-if="scope.row.pic_id" style="display: inline-block;">
                            <m-img v-for="(it,index) in scope.row.pic_list" :key="index" :src="it"  />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="客服回复" align="center" min-width="150">
                     <template slot-scope="scope">
                       <p v-if="scope.row.kf_reply">{{scope.row.kf_reply.kf_info ? scope.row.kf_reply.kf_info.kf : '商家回复'}}: <span style="margin-left:15px">{{scope.row.kf_reply.content}}</span> </p>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="评价时间"  width="160"  align="center"></el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button  @click="showModel(scope.row)" type="success" plain size="mini" style="margin:5px 0 0 0">回复评论</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  background layout="prev, pager, next, jumper" :total="total" :page-size="size" @current-change="loadData" style="padding:15px 15px 15px 0"></el-pagination>
        </el-card>

        <el-dialog :visible.sync="dialog" width="600px" center>
           <el-card >
               <el-row class="m-bottom-4">
                    <el-col :span="4" style="line-height:40px">
                        选择客服：
                    </el-col>
                    <el-col :span="20">
                        <el-select v-model="kf_id" placeholder="请选择" style="width:100%">
                            <el-option v-for="item in options"  :key="item.id" :label="item.kf"  :value="item.id"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row class="m-bottom-4">
                    <el-col :span="4" style="line-height:40px">
                        回复内容：
                    </el-col>
                    <el-col :span="20">
                        <el-input  type="textarea" :rows="3" placeholder="请输入内容" v-model="reply" maxlength="140" show-word-limit resize="none"></el-input>
                    </el-col>
                </el-row>
                <el-row >
                    <el-col :span="4" style="line-height:40px">
                        提交回复：
                    </el-col>
                    <el-col :span="20">
                        <el-button  @click="onSubmit()" type="success" plain>Submit</el-button>
                    </el-col>
                </el-row>  
            </el-card>
        </el-dialog>
    </section>
</template>
<script>
import { comment_list, comment_add  } from '@/api/goods.js'
import MImg   from './../../../components/Image'
import MVideo from '@/components/video.vue'
import { cusmoter } from '@/api/platform.js'
import { parseTime }  from '@/untils/index.js'
export default {
    components: { MImg, MVideo },
    data() {
        return {
            name:'',
            tableData:[],
            total: 0,
            page: 1,
            size: 10,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
            
            options: [],
            row: {},
            dialog: false,
            kf_id: '',
            reply: '',
        }
    },
    methods:{
        search(){
            this.gage = 1
            this.getData()
        },
        getData(){
            let params = {
                flag: 2,
                page: this.page,
            }
            if(this.name != '') {
               params.name = this.name
            }
            comment_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.tableData.forEach(item => {
                        item.created_at = parseTime(item.created_at)
                    })
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                    this.total = 0
                }
            })
        },
        loadData(page) {
            this.page = page
            this.getData()
        },
        getCusmoter() {
            cusmoter().then(res => {
                if(res){
                    this.options = res.data
                }
            })
        },
        showModel(row) {
            this.row    = row
            this.dialog = true
        },
        onSubmit() {
            let params = {
                comment_id: this.row.id,
            }
            if(this.kf_id == ''){
                this.$message.error("请选择回复客服")
                return false
            }
            params.kf_id = this.kf_id
            if(this.reply == ''){
                this.$message.error("请输入回复内容")
                return false
            }
            params.content = this.reply
            comment_add(params).then(res => {
                if(res) {
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.getData()
                }
            }).finally(() => {
                this.dialog = false
            })
        }
    },
    created(){
        this.getData()
        this.getCusmoter()
    },
    activated() {
        this.getData()
    },

        
}
</script>
<style lang="less" scoped>

section {
  .stars {
        // display: flex;
        // margin-bottom: 15px;
        &>p {
            display: flex;
            align-items: center;
            margin-right: 30px;
        }
        &>p:last-child {
            margin: 0;
        }
        .icon-star {
            margin-left: 10px;
            &>i {
                font-size: 20px;
                color: #FF9800;
                vertical-align: text-top;
            }
        }
    }
}
.el-image  + .el-image  {
    margin-left: 20px;
}
.m-img-upload {
    margin-right: 15px;
    width: 70px;
    height: 70px;
    display: inline-block !important;
}
</style>
